import GameSignals from '@/signals/GameSignals'
import { BaseChildState } from '@stateMachine/BaseChildState'

export class FreeSpinsIntroState extends BaseChildState {
    private _introFallbackTimeoutId: number = null
    private _transitionFallbackTimeoutId: number = null
    private _isConfirmed: boolean = false
    private _isCompleted: boolean = false

    public canTrigger(): boolean {
        return this._model.spinData.freebet &&
            this._model.spinData.freebet.amount_left === this._model.spinData.freebet.total_amount_given &&
            !this._model.roundState.isFreeSpins &&
            !this._model.isPromoSpinsRound()
    }

    public begin() {
        GameSignals.showFreeSpinsIntroComplete.connect(this.onIntroComplete)
        GameSignals.completeTransitionAnimation.connect(this.onTransitionComplete)

        this._isConfirmed = false
        this._isCompleted = false

        this._model.isBonusGameNow = true
        this._model.roundState.isFreeSpins = true

        GameSignals.showFreeSpinsIntro.emit(this._model.spinData.bonus.freebet_given)
        GameSignals.showFreeSpinsBackground.emit()

        // Safety fallback in case popup component is not available
        this._introFallbackTimeoutId = window.setTimeout(this.onIntroComplete, 3000)
    }

    private onIntroComplete = () => {
        if (this._isConfirmed) {
            return
        }

        this._isConfirmed = true

        if (this._introFallbackTimeoutId !== null) {
            clearTimeout(this._introFallbackTimeoutId)
            this._introFallbackTimeoutId = null
        }

        GameSignals.bonusStart.emit()

        // Safety fallback in case transition animation does not emit completion
        this._transitionFallbackTimeoutId = window.setTimeout(this.onTransitionComplete, 2000)
    }

    private onTransitionComplete = () => {
        if (this._isCompleted) {
            return
        }

        this._isCompleted = true

        if (this._transitionFallbackTimeoutId !== null) {
            clearTimeout(this._transitionFallbackTimeoutId)
            this._transitionFallbackTimeoutId = null
        }

        GameSignals.bonusStartComplete.emit()
        this.end()
    }

    public cleanUp() {
        if (this._introFallbackTimeoutId !== null) {
            clearTimeout(this._introFallbackTimeoutId)
            this._introFallbackTimeoutId = null
        }

        if (this._transitionFallbackTimeoutId !== null) {
            clearTimeout(this._transitionFallbackTimeoutId)
            this._transitionFallbackTimeoutId = null
        }

        GameSignals.showFreeSpinsIntroComplete.disconnect(this.onIntroComplete)
        GameSignals.completeTransitionAnimation.disconnect(this.onTransitionComplete)
    }
}
